<template>
	<div class="box">
		<!--退回-->
		<!-- <div class="box_top_info">
            <img class="back_img"
                 src="@/assets/homeImgs/black_back.png"
                 @click="backToLast"/>
            <div class="address_manage">我的授信</div>
        </div> -->
		<div class="scroll-content">
			<!-- <div class="balance">
				<div class="balance_text">剩余额度</div>
				<div class="line"></div>
				<div class="balance_text_two">剩余可以用（元）</div>
				<div class="balance_number">{{ availableCreditMoney }}</div>
				<div class="balance_info">
					<div class="myArrears">我的欠款:{{ debtMoney }}</div>
					<div class="notCredited">未入账:{{ unpaidMoney }}</div>
					<div class="totalAmount">总额度:{{ totalCreditMoney }}</div>
				</div>
			</div> -->
			<!-- <div class="data-list"> -->
				<!-- <div class="bill_text">账单明细</div> -->
				<!-- 切换状态tab栏 -->
				<van-tabs
					class="bill_row"
					v-model="active"
					sticky
					@change="changeTab"
					title-active-color="#3377FF"
					color="#3377FF"
					title-inactive-color="#666666"
				>
					<van-tab
						v-for="(item) in tabs"
						:key="item.key"
						:title="item.label"
						:name="item.key"
					>
						<van-list
							v-model="loading"
							:finished="finished"
							:finished-text="
								list.length === 0 ? '' : '没有更多了'
							"
							@load="onload"
						>
							<div
								class="bill-info"
								v-for="(item1, index) in list"
								:key="index"
							>
								<div class="bill_text">
									<div
										v-if="item1.changeType == '支出'"
										class="bill_name"
									>
										{{
											(item1.targetName
												? item1.targetName
												: item1.payerName) +
											'支付' +
											item1.orderId
										}}
										<br>{{ item1.orderId }}
									</div>
									<div
										v-if="item1.changeType == '退款'"
										class="bill_name"
									>
										{{ item1.orderId + '订单退款' }}
									</div>
									<div
										v-if="item1.changeType == '还款'"
										class="bill_name"
									>
										{{ item1.creditDesc }}
									</div>
									<div
										v-if="item1.changeType == '提额'"
										class="bill_name"
									>
										{{ item1.creditDesc || '授信充值' }}
									</div>
									<div
										v-if="item1.changeType == '降额'"
										class="bill_name"
									>
										授信降额
									</div>
									<div
										v-if="item1.changeType == '佣金到账'"
										class="bill_name"
									>
										{{ item1.creditDesc }}
									</div>
								</div>
								<div class="time-box">
									<div class="bill_time">
										{{ item1.createTime }}
									</div>
									<div>
										<span
											class="bill_price active_bill_price"
											:style="{
												color:
													(item1.changeType == '支出' || item1.changeType == '降额')
														? '#ff3333'
														: 'green',
											}"
											v-if="item1.changeQuota >= 0"
											><span v-if="item1.changeType == '支出' || item1.changeType == '降额'"
												>-</span
											>
											<span v-else>+</span
											>
											{{ item1.changeQuota }}
										</span>
										<span class="bill_price" v-else>{{
											item1.changeQuota
										}}</span>
									</div>
								</div>
							</div>
							<van-empty
								description="暂无记录"
								v-if="list.length === 0"
							/>
						</van-list>
					</van-tab>
				</van-tabs>
			<!-- </div> -->
		</div>
	</div>
</template>

<script>
export default {
	name: 'myCredit',
	data() {
		return {
			// availableCreditMoney: '0.00', //剩余可用
			// debtMoney: '0.00', //欠款
			// totalCreditMoney: '0.00', //总额度
			// unpaidMoney: '0.00', //未入账
			active: 0,
			// tabs: ['全部', '支出', '退款', '还款', '提额', '降额', '佣金到账'],
			tabs:[
				{
					key:0,
					label:'全部',
				},
				{
					key:1,
					label:'支出',
				},
				{
					key:2,
					label:'退款',
				},
				{
					key:4,
					label:'提额',
				},
				{
					key:5,
					label:'降额',
				},
				{
					key:6,
					label:'佣金到账',
				},
			],
			list: [],
			loading: false,
			finished: false,
			userId: '',
			pageNum: 0,
		}
	},
	mounted() {
		this.userEntity1 = this.$store.state.userInfo_v2.user
		this.userEntity2 = this.$store.state.userInfo_v2.identity

		this.distributorId = this.userEntity2.distributorId
		this.userInfo = this.$store.state.userInfo_v2.user
		this.userId = this.userInfo.userId

		// this.queryMyCredit()
	},
	methods: {
		//返回
		backToLast() {
			this.$router.go(-1)
		},
		/* 2022.8.5注释 UI不展示这部分信息 */
		//我的授信
		// queryMyCredit() {
		// 	//如果是分销员
		// 	var params = {}
		// 	if (this.userEntity2.identityType == '4') {
		// 		params = {
		// 			distributorId: this.userId,
		// 			current: '1',
		// 			userLevel: '3',
		// 			consumeType: 1,
		// 		}
		// 	} else {
		// 		params = {
		// 			distributorId: this.distributorId,
		// 			current: '1',
		// 			userLevel: '2',
		// 			consumeType: 1,
		// 		}
		// 	}
		// 	this.$API.x_person.myCredit(params).then((res) => {
		// 		this.availableCreditMoney = res.data.availableCreditMoney //剩余可用
		// 		this.debtMoney = res.data.debtMoney //欠款
		// 		this.totalCreditMoney = res.data.totalCreditMoney //总额度
		// 		this.unpaidMoney = res.data.unpaidMoney //未入账
		// 	})
		// },
		requestCreatList() {
			// var params = {
			// 	consumeType: this.active ? [this.active] : [],
			// 	agentId: '',
			// 	currentPage: this.pageNum,
			// 	pageSize: 20,
			// 	distributorId: '',
			// 	organizationId: this.userInfo.tenantId,
			// }
			/** 2022.8.5 修改为v3接口 */
			var params = {
				changeType: this.active ? this.active : '',
				pageNum: this.pageNum,
				pageSize: 20,
			}
			// if (this.userEntity2.identityType == '3') {
			// 	params.distributorId = this.distributorId
			// } else {
			// 	params.agentId = this.distributorId
			// 	params.distributorId = this.userId
			// }
			this.$API.v3.distribution
				.postV3RecordsCredit(params)
				.then((res) => {
					this.loading = false
					if (res.data) {

						if (this.pageNum === 1) {
							this.list = res.data.list
						} else {
							this.list = [...this.list, ...res.data.list]
						}

						this.loading = false
						this.finished = this.list.length >= res.data.total
					} else {
						if (this.pageNum === 1) {
							this.list = []
							this.finished = true
						}
					}
				})
				.catch((err) => {
					this.finished = true
					this.loading = false
				})
		},
		onload() {
			this.loading = true
			this.finished = false
			this.pageNum++
			this.requestCreatList()
		},
		changeTab() {
			this.loading = true
			this.finished = false
			this.pageNum = 1
			this.requestCreatList()
		},
		productCellClick() {},
	},
}
</script>

<style lang="scss" scoped>
.box {
	background-color: #f4f6f9;
	height: 100%;
	overflow: hidden;

	.scroll-content {
		height: 100%;
		overflow-y: auto;
		.balance {
			height: vw(297);
			margin-top: vw(32);
			margin-left: vw(32);
			margin-right: vw(32);
			padding-bottom: vw(30);
			background-color: $theme-color;
			opacity: 1;
			border-radius: vw(12);

			.balance_text {
				padding-top: vw(32);
				margin-left: vw(32);
				font-size: vw(30);
				font-family: Source Han Sans CN;
				color: #ffffff;
				opacity: 1;
			}

			.line {
				margin-top: vw(24);
				width: vw(686);
				height: vw(1);
				background: $theme-color;
			}

			.balance_text_two {
				margin-top: vw(24);
				margin-left: vw(32);
				font-size: vw(24);
				font-family: Source Han Sans CN;
				color: #ffffff;
			}

			.balance_number {
				// margin-top: vw(-10);
				margin-left: vw(32);
				font-size: vw(54);
				font-family: Source Han Sans CN;
				font-weight: bold;
				color: #ffffff;
			}

			.balance_info {
				margin-top: vw(30);
				margin-left: vw(32);
				display: flex;
				flex-direction: row;
				justify-content: space-between;

				.myArrears {
					font-size: vw(24);
					font-family: Source Han Sans CN;
					color: #ffffff;
					opacity: 0.8;
				}

				.notCredited {
					font-size: vw(24);
					font-family: Source Han Sans CN;
					color: #ffffff;
					opacity: 0.8;
				}

				.totalAmount {
					padding-right: vw(32);
					font-size: vw(24);
					font-family: Source Han Sans CN;
					color: #ffffff;
					opacity: 0.8;
				}
			}
		}
		.data-list {
			background-color: white;
			padding: vw(32);
			margin: vw(32);
			border-radius: vw(12);
		}
		.bill_text {
			padding-top: vw(40);
			// padding-bottom: vw(20);
			font-size: vw(30);
			font-family: Source Han Sans CN;
			//font-weight: bold;
			color: #333333;
			opacity: 1;
		}

		.bill-info {
			//margin-top: vw(2);
			//height: vw(138);
			background-color: #ffffff;
			padding: 0 vw(32);

			.bill_text {
				padding-top: vw(30);

				.bill_name {
					height: vw(40);
					font-size: vw(30);
					font-family: Source Han Sans CN;
					color: #333333;
					opacity: 1;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
			}

			.time-box {
				display: flex;
				align-items: center;
				flex-direction: row;
				justify-content: space-between;
				.bill_price {
					margin-left: vw(10);
					text-align: center;
					width: vw(230);
					height: vw(40);
					font-size: vw(30);
					font-family: Source Han Sans CN;
					color: #ff3333;
					opacity: 1;
				}
				.active_bill_price {
					color: green;
				}
				.bill_time {
					margin-top: vw(10);
					width: vw(300);
					height: vw(24);
					font-size: vw(24);
					font-family: Source Han Sans CN;
					color: #999999;
					opacity: 1;
					flex: 1;
				}
			}
		}
	}
}
</style>
